module.exports = __webpack_public_path__ + "static/media/descargar.8c3c8e57.png";